<template>
    <div class="PreSearchGrid">
        <ais-infinite-hits>
            <div slot-scope="{ items, refineNext, isLastPage }">
                <ul class="grid grid--medium">
                    <li
                        v-for="item in items"
                        :key="item.id"
                        class="grid__item smart-one-whole one-half lap-and-up-one-third"
                    >
                        <PreSearchHit 
                            :item="item"
                            :fallback-image="fallbackImage" />
                    </li>
                </ul>
                <HrLine v-if="!isLastPage" />
                <BaseButton
                    v-if="!isLastPage"
                    tag="button"
                    modifier="medium"
                    @click="refineNext"
                >
                    View more
                </BaseButton>
            </div>
        </ais-infinite-hits>
    </div>
</template>

<script>
function getFacetSlug(name) {
    return name
        .toLowerCase()
        .replace('&', 'and')
        .replace(', ', '--')
        .split(' ')
        .map(encodeURIComponent)
        .join('-');
}

export default {
    props: {
        fallbackImage: {
            type: String
        }
    }
}
</script>
<style lang="scss" scoped>
    .PreSearchGrid {
        margin-top: getSpacing('large');
        margin-bottom: getSpacing('large');

        @include media-query(desk) {
            margin-top: getSpacing('xlarge');
            margin-bottom: getSpacing('xlarge');
        }

        @include media-query(palm) {
            margin-top: getSpacing('medium');
            margin-bottom: getSpacing('medium');
        }

        &::v-deep .image {
            object-fit: cover;
        }

        .BaseButton {
            display: block!important;
            margin: auto;
            cursor: pointer;
            margin-bottom: getSpacing(large);
        }

        .HrLine {
            margin-top: getSpacing(large);
            margin-bottom: getSpacing(large);
            padding: 0;

            @include media-query(palm) {
                margin-top: getSpacing('medium');
                margin-bottom: getSpacing('medium');
            }
        }

        .BaseIcon {
            position: relative;
            top: 2px;
        }
    }
</style>
